export type WithTypename<T> = { __typename: string } & T;

export interface Localizable<T> {
  [locale: string]: T;
}

export type LocalizableString = Localizable<string>;

export type LocalizableImage = Localizable<{ originalImageUrl: string }>;

export enum CfVideoState {
  Downloading = 'DOWNLOADING',
  Inprogress = 'INPROGRESS',
  Ready = 'READY',
  Error = 'ERROR'
}

export type LocalizableVideo = Localizable<{
  playbackUrl: string;
  cfHlsUrl: string;
  cfState: CfVideoState;
  cfVideoId: string;
}>;

export type LocalizableFile = Localizable<{ fileUrl: string; filename: string }>;

export type BoothContentElement = WithTypename<{
  id: string;
  contentRichtextHtml?: LocalizableString;
  image?: LocalizableImage;
  videoFile?: LocalizableVideo;
  file?: LocalizableFile;
  question?: LocalizableString;
  answer?: BoothContentElement;
}>;
